<script lang="ts">
	import { Helper, Radio } from "flowbite-svelte";
	import { RecommendationType } from "#gen/products/v1/service_pb.js";
	import TogglePane from "#lib/components/TogglePane.svelte";
	import type { ComponentEditingProps } from "#lib/components/page/ComponentProps.js";
	import EditorInset from "#lib/components/page/editing/EditorInset.svelte";
	import { numberValue, setNumberValue, setStructValue, structValue } from "#lib/struct.js";
	import type { JsonObject } from "@bufbuild/protobuf";

	let { id, page, onChange }: ComponentEditingProps = $props();

	const value = $derived(numberValue(structValue($page.config, id), "recommendation_type") ?? RecommendationType.RELATED);

	export function validate(): boolean {
		return true;
	}

	function update(value: RecommendationType) {
		let config = structValue($page.config, id);
		if (!config) {
			config = {} as JsonObject;
			setStructValue($page.config, id, config);
		}
		setNumberValue(config, "recommendation_type", value);
		$page = $page;
		onChange?.(value);
	}
</script>

<EditorInset>
	<TogglePane enabled={true} label="Recommendation type">
		{#snippet control()}<div></div>{/snippet}
		<div class="flex flex-col gap-6">
			<div>
				<Radio name="recommendation_type" value={RecommendationType.RELATED} group={value} on:change={() => update(RecommendationType.RELATED)} aria-describedby="related-help">Related Products</Radio>
				<Helper id="related-help" class="pl-6">Offer customers a mix of products that are similar or complementary to a product for which recommendations are to be fetched. An example is substitutable products that display in a You may also like section.</Helper>
			</div>
			<div>
				<Radio name="recommendation_type" value={RecommendationType.COMPLEMENTARY} group={value} on:change={() => update(RecommendationType.COMPLEMENTARY)} aria-describedby="helper-checkbox-text">Complementary Products</Radio>
				<Helper id="helper-checkbox-text" class="pl-6">Offer customers products that are complementary to a product for which recommendations are to be fetched. An example is add-on products that display in a Pair it with section.</Helper>
			</div>
		</div>
	</TogglePane>
</EditorInset>
